import * as React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import wrapDisplayName from 'react-wrap-display-name';
import FormContext from '../context';

var withFormContext = function withFormContext(WrappedComponent) {
  var _Component = function _Component(props) {
    return React.createElement(FormContext.Consumer, null, function (formContext) {
      return React.createElement(WrappedComponent, Object.assign({}, props, {
        formContext: formContext
      }));
    });
  };

  _Component.WrappedComponent = WrappedComponent;
  _Component.displayName = wrapDisplayName(WrappedComponent, 'withFormContext');
  hoistStatics(_Component, WrappedComponent);
  return _Component;
};

export default withFormContext;